import { Injectable } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'

export const ADMIN_ROUTES = Object.freeze({
  HOME: '/home',
  ACCOUNT: '/account',
  NOT_FOUND: '/404',
  LOGIN: '/auth/login',
  AUTH_RECOVER: '/auth/recover',
  AUTH_CODE: '/auth/code',
  TESTING: '/testing',
  REPORTING: '/reporting',
  REPORTING_USERS_NETWORK: '/reporting/users/network',
  REPORTING_USERS_EMPLOYER: '/reporting/users/employer',
  REPORTING_RECRUITING: '/reporting/recruiting',
  REPORTING_RECRUITING_JOB_POSTS: '/reporting/recruiting/job-posts',
  REPORTING_RECRUITING_APPLICATIONS: '/reporting/recruiting/applications',
  REPORTING_RECRUITING_ENGAGEMENT: '/reporting/recruiting/engagement',
  REPORTING_RECRUITING_COMPLIANCE: '/reporting/recruiting/compliance',
  REPORTING_RECRUITING_CAREERS: '/reporting/recruiting/careers',
  REPORTING_TENANTS: '/reporting/tenants',
  REPORTING_TENANTS_CLIENTS: '/reporting/tenants/clients',
  REPORTING_ACTIVITY_INTERACTIONS: '/reporting/activity/interactions',
  REPORTING_LIFECYCLE_SIGNUPS: '/reporting/lifecycle/signups',
  REPORTING_LIFECYCLE_TRIALS: '/reporting/lifecycle/trials',
  REPORTING_LIFECYCLE_CONVERSIONS: '/reporting/lifecycle/conversions',
  REPORTING_LIFECYCLE_DORMANT: '/reporting/lifecycle/dormant',
  CRM: '/crm',
  CRM_SEARCH: '/crm/search',
  CRM_ACCOUNTS: '/crm/accounts',
  CRM_CONTACTS: '/crm/contacts',
  CRM_DEALS: '/crm/deals',
  CRM_TASKS: '/crm/tasks',
  CRM_PIPELINE: '/crm/pipeline',
  CRM_ACCOUNT: '/crm/account',
})

@Injectable({ providedIn: 'root' })
export class AdminNavigationService {
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  toLogin() {
    this.router.navigate([ADMIN_ROUTES.LOGIN])
  }

  toHome() {
    this.router.navigate([ADMIN_ROUTES.HOME])
  }

  toRecover() {
    this.router.navigate([ADMIN_ROUTES.AUTH_RECOVER])
  }

  addQueryParams(queryParams: Params) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
      queryParamsHandling: 'merge',
    })
  }

  updateQueryParams(queryParams: Params) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
    })
  }
}
